import { render, staticRenderFns } from "./testRegistration.vue?vue&type=template&id=dfc4fd4c"
import script from "./testRegistration.vue?vue&type=script&lang=js"
export * from "./testRegistration.vue?vue&type=script&lang=js"
import style0 from "./testRegistration.vue?vue&type=style&index=0&id=dfc4fd4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports